export enum ScriptLanguage {
  JavaScript = "javascript",
  Python = "python",
}

/** A lint marker the editor places, located by JSON pointer (`""` addresses the root). */
export type JsonLintIssue = { pointer: string; message: string }

/**
 * Decides whether a parsed JSON document is acceptable, and says why it is not.
 * Supplied by the caller so the editor stays unaware of any particular schema.
 */
export type JsonValidator = (value: unknown) => JsonLintIssue[]
